import { useQuery } from '@apollo/react-hooks';

import { useStoreActions } from '@/store';
import type {
  DeferredFeatureQuery,
  DeferredFeatureQueryVariables,
} from '@/generated/graphql';
import { DEFERRED_FEATURE_QUERY } from './deferredFeatureQuery.gql';
import { hasTreatment } from '../utils';
import { iwcAutofillEmailLookup } from '@/lib/emailLookup';
import {
  getGlobals,
  getLocale,
  getToken,
  logger,
  updateExperiments,
  updateIwcContext,
} from '@/lib';
import { features } from '../index';

export const useDeferredFeatures = (): void => {
  const setCheckForMemberBenefits = useStoreActions(
    ({ ui }) => ui.setCheckForMemberBenefits,
  );
  const { device, isBasl } = getGlobals();
  const { country } = getLocale();

  const { loading, error, data } = useQuery<
    DeferredFeatureQuery,
    DeferredFeatureQueryVariables
  >(DEFERRED_FEATURE_QUERY, {
    variables: {
      channel: device?.channel,
      countryCodeAsString: country,
      integrationType: 'XoSignupAuth',
      isBaslAsString: `${isBasl}`,
      isForcedGuest: `${features.get('isForcedGuest')}`,
      token: getToken(),
    },
  });

  if (!loading && !error && data) {
    const { elmoExperiment, otpLoginContext } = data;

    getGlobals().deferredQueryData.elmoExperiment = elmoExperiment;
    if (otpLoginContext) {
      updateIwcContext(otpLoginContext.context);
    }

    updateExperiments();
    iwcAutofillEmailLookup();

    if (hasTreatment('FEATURE_MEMBER_AS_DEFAULT')) {
      setCheckForMemberBenefits(true);
    }
  } else if (error) {
    const { message, stack } = error;
    logger.warn('useDeferredFeatures_error', { message, stack });
  }
};
